"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TermsAndConditionsList = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _Sanitizer = require("../../base-components/Sanitizer/Sanitizer");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var TermsAndConditionsList = exports.TermsAndConditionsList = function TermsAndConditionsList(_ref) {
  var content = _ref.content,
    qeId = _ref.qeId,
    styles = _ref.styles;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.descriptions,
    "data-qe-id": qeId
  }, !!content.length && content.map(function (_ref2, contentIndex) {
    var header = _ref2.header,
      desc = _ref2.desc,
      nestedContent = _ref2.content;
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: "TermsAndConditionsList_".concat(String(contentIndex)),
      className: (0, _classnames2["default"])(styles.description, _defineProperty({}, styles.noHeader, !header))
    }, /*#__PURE__*/_react["default"].createElement(_Sanitizer.Sanitizer, {
      className: styles.descriptionHeader,
      safelySetInnerHTML: header,
      Component: "div"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: styles.descriptionList
    }, nestedContent ? /*#__PURE__*/_react["default"].createElement(TermsAndConditionsList, {
      content: nestedContent,
      styles: styles
    }) : !!desc.length && desc.map(function (_ref3, descIndex) {
      var text = _ref3.text;
      return /*#__PURE__*/_react["default"].createElement(_Sanitizer.Sanitizer, {
        key: "desc_".concat(String(descIndex)),
        className: styles.descriptionListItem,
        safelySetInnerHTML: text,
        Component: "div"
      });
    })));
  }));
};
TermsAndConditionsList.propTypes = {
  content: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    header: _propTypes["default"].string,
    desc: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      text: _propTypes["default"].string
    }))
  })),
  qeId: _propTypes["default"].string,
  styles: _propTypes["default"].objectOf(_propTypes["default"].string)
};
TermsAndConditionsList.defaultProps = {
  content: [],
  qeId: undefined,
  styles: {}
};